module.exports = __webpack_public_path__ + "img/gov_hover.c174566a.png";